import type { RunCmd } from "./dispatch";

/**
 * Run Cmds after the model has been applied.
 * Like Elm `Cmd.batch`: start together, do not await one-by-one.
 */
export async function runCmds<Cmd>(
  cmds: readonly Cmd[],
  runCmd: RunCmd<Cmd>,
): Promise<void> {
  await Promise.all(cmds.map((cmd) => runCmd(cmd)));
}
